import type IUiFieldsFactory from '@/common/services/Fields/IUiFieldsFactory'
import UIFieldsFactory from '@/common/services/Fields/UIFieldsFactory'
import {injectable, inject} from 'inversify'
import { SingletonService } from "@/common/dependency.configs";

@SingletonService
@injectable()
class EmpUiFielsFactory implements IUiFieldsFactory {
  constructor(
    @inject(UIFieldsFactory)
    private uiFieldsFactory: UIFieldsFactory
  ) {}
  get(messageCategoryId: number) {
    return this.uiFieldsFactory.get(messageCategoryId)
  }
  getAll() {
    return this.uiFieldsFactory.getAll()
  }
}
export default EmpUiFielsFactory
